const lightboxInits = () => {
	const gallerySliderLightbox = GLightbox({
		selector: 'gallery__slider-lightbox',
	    touchNavigation: true,
	    loop: true
	});
};